// ============================================
// Horizontal Scroll - Scroll button visibility and click handling
// ============================================

/**
 * Initialize horizontal scroll functionality
 * - Shows/hides scroll button based on overflow
 * - Handles scroll button click to scroll container
 */
export function initHorizontalScroll() {
  const wrappers = document.querySelectorAll('[data-scroll-container]');

  wrappers.forEach(container => {
    // Find the scroll button (sibling of the container's parent)
    const wrapper = container.closest('.p-video-series__cards-wrapper');
    if (!wrapper) return;

    const scrollBtnWrapper = wrapper.querySelector('[data-scroll-right]');
    const scrollBtn = scrollBtnWrapper?.querySelector('button');
    const fadeOverlay = wrapper.querySelector('.p-video-series__cards-fade');

    if (!scrollBtnWrapper || !scrollBtn) return;

    /**
     * Check if container has overflow and update button visibility
     */
    function checkOverflow() {
      const hasOverflow = container.scrollWidth > container.clientWidth;
      const isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;

      // Hide button wrapper if no overflow or at end of scroll
      if (!hasOverflow || isAtEnd) {
        scrollBtnWrapper.classList.add('p-video-series__scroll-btn--hidden');
        if (fadeOverlay) fadeOverlay.style.opacity = '0';
      } else {
        scrollBtnWrapper.classList.remove('p-video-series__scroll-btn--hidden');
        if (fadeOverlay) fadeOverlay.style.opacity = '1';
      }
    }

    /**
     * Scroll container by one card width (approximate)
     */
    function scrollRight() {
      const cardWidth = 282 + 24; // card width + gap
      const maxScroll = container.scrollWidth - container.clientWidth;
      const newScrollLeft = Math.min(container.scrollLeft + cardWidth, maxScroll);

      container.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }

    // Initial check
    checkOverflow();

    // Check on scroll to update button visibility
    container.addEventListener('scroll', () => {
      requestAnimationFrame(checkOverflow);
    });

    // Check on resize
    window.addEventListener('resize', () => {
      requestAnimationFrame(checkOverflow);
    });

    // Click handler
    scrollBtn.addEventListener('click', scrollRight);
  });
}
